import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Container } from '../../ui/Container';
const items = [{
  label: 'Kids Programs',
  cta: 'Explore',
  to: '/en/children/kids-programs',
  image: 'https://cdn.magicpatterns.com/uploads/bVektgjSsyyb4QP9K5hGbC/kids-1.jpg'
}, {
  label: 'Online Learning',
  cta: 'How it Works',
  to: '/en/children/online-learning',
  image: 'https://cdn.magicpatterns.com/uploads/jjNQUzfbm3fVgHUYbPU5fW/online-learning.jpg'
}, {
  label: 'Values & Identity',
  cta: 'Learn More',
  to: '/en/children/values-identity',
  image: 'https://cdn.magicpatterns.com/uploads/hWerU51G2oHuKfx2gJNfg5/img2.jpg'
}, {
  label: 'Scholarships',
  cta: 'Support Options',
  to: '/en/children/scholarships',
  image: 'https://cdn.magicpatterns.com/uploads/8awkEnkAr35x3W2oQBLASf/Scholar-3.jpg'
}];
export function CoreResponsibility() {
  return <section className="relative py-20 md:py-28 bg-forest-700 text-ivory overflow-hidden" data-id="element-584" data-mp="cd7ibvvxy2vg">
      {/* Top & bottom geometric border */}
      <div className="absolute inset-x-0 top-0 h-3 bg-[repeating-linear-gradient(45deg,rgba(232,217,176,0.4)_0_8px,transparent_8px_16px)]" data-id="element-585" data-mp="m9u0ue0sohub" />
      <div className="absolute inset-x-0 bottom-0 h-3 bg-[repeating-linear-gradient(45deg,rgba(232,217,176,0.4)_0_8px,transparent_8px_16px)]" data-id="element-586" data-mp="r9yhq55m7el2" />

      <Container className="relative" data-id="element-587" data-mp="v8o5mroa4eiy">
        <div className="text-center max-w-3xl mx-auto" data-id="element-588" data-mp="108tqnp01n2s2">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sand-300/20 text-sand-200 text-[11px] font-semibold tracking-[0.14em] uppercase" data-id="element-589" data-mp="1078uxw1ztdsm">
            For Children
          </span>
          <h2 className="font-display text-3xl md:text-5xl text-ivory leading-tight mt-5" data-id="element-590" data-mp="1eyhscrc503gb">
            Children Are Our Core Responsibility
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-7" data-id="element-591" data-mp="1j0cs3ref68rz">
          {items.map((item, i) => <motion.div key={item.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} whileHover={{
          y: -4
        }} data-id="element-592" data-mp="3fycx4mjo3182" data-mpi={i}>
              <Link to={item.to} className="group flex flex-col items-center" data-id="element-593" data-mp="blpvg3qikp93">
                <div className="relative w-full aspect-[4/3] rounded-[28px] overflow-hidden border-2 border-sand-300/50 shadow-card" data-id="element-594" data-mp="7m8nn3nm7g0r">
                  <img src={item.image} alt={item.label} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-595" data-mp="2dfp5ymvtb2kq" />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest-800/60 via-transparent to-transparent" data-id="element-596" data-mp="23aguwjsndpr6" />
                </div>
                <div className="mt-4 text-center" data-id="element-597" data-mp="1pi0wxxelshx4">
                  <h3 className="font-display text-lg text-ivory" data-id="element-598" data-mp="1uhdi8dpttgxl">
                    {item.label}
                  </h3>
                  <span className="inline-flex items-center gap-1.5 mt-2 px-4 py-1.5 rounded-full bg-sand-300 text-ink-900 text-xs font-medium group-hover:bg-sand-400 transition" data-id="element-599" data-mp="1fjbf24mpixgv">
                    {item.cta}
                    <ArrowRightIcon size={12} data-id="element-600" data-mp="16kzq071ho7qj" />
                  </span>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}